export default "/packs/6a9825180c7b3cd68fc966ad82a9f245.svg";